import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import { queryClient } from '@/library/react-query';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { PreferredBankReq, PreferredBankRes } from './types';

const updatePreferredBank = async (
  payload: PreferredBankReq & { customerId: string }
): Promise<PreferredBankRes> => {
  const res = await axios<
    PreferredBankRes,
    BaseResponse<PreferredBankRes>,
    PreferredBankReq
  >({
    url: `/ucic/bank/${payload.customerId}/preference-without-doc-verification`,
    method: 'post',
    data: {
      bankId: payload.bankId,
      ucicNo: payload.ucicNo,
    },
  });

  return res?.data?.data;
};

export const useChangePreferredBank = () => {
  const { mutateAsync, isLoading, error } = useMutation(updatePreferredBank, {
    onSuccess: () => {
      queryClient.invalidateQueries('bank-details');
    },
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { changePreferredBank: mutateAsync, isLoading };
};
